<template>
    <div class="schedule-block" :class="{ passed: isBlockPassed }" ref="blockRef">
        <span class="label">&nbsp;{{ label }}</span>
        <DayScheduleItem v-for="(bell, index) in slots" :bell="bell" :class="{ passed: isBlockCurrent && isSlotPassed(bell, index) }"/>
        <span class="current-time-marker" v-if="isBlockCurrent" ref="currentTime" :style="{ height: calculateCurrentTimePosition(currentTimeFormatted) }"></span>
    </div>
</template>

<script>
import DayScheduleItem from './DayScheduleItem.vue';
import moment from 'moment';

export default {
    props: ['hour', 'division', 'bells', 'current_time'],
    components: { DayScheduleItem },
    data() {
        return {
            slots: [null, null, null, null, null, null]
        }
    },
    methods: {
        isSlotPassed(slot, index) {
            const currentMinutes = moment(this.current_time, 'hh:mm a').minutes();
            const currentSlotIndex = this.slotHash(currentMinutes);
            return (slot === null && currentSlotIndex > index) ||
                (slot !== null && moment(slot.schedule_time, 'hh:mm a').isBefore(moment(this.current_time, 'hh:mm a').startOf('minute')))
        },
        calculateCurrentTimePosition(time) {
            const currentMinutes = moment(time, 'hh:mm a').minutes();
            const currentSlotIndex = this.slotHash(currentMinutes);
            const passedSlots = this.slots.filter(this.isSlotPassed);

            if(this.slots[currentSlotIndex] === null) {
                return `${this.calculatePositionFromTime(time)}px`
            }

            if(passedSlots.length > 0) {
                return `${20 * passedSlots.length}px`
            }

            return `${this.calculatePositionFromTime(time)}px`;
        },
        calculatePositionFromTime(time) {
            let minute = time.substring(0, time.length - 3).split(':')[1];
            minute = Number(minute) % 30;
            const pxPerMinute = 120 / 30;
            return minute * pxPerMinute;
        },
        slotHash(key) {
            const numSlots = 6;
            const minutesPerDivision = 30;
            return Math.floor((key % minutesPerDivision) / (numSlots - 1));
        }
    },
    computed: {
        label() {
            let result = '';
            if(this.hour === 0 || this.hour === 24) result += 12;
            else if(this.hour > 12) result += this.hour - 12;
            else result += this.hour;
            result += ':';
            result += this.division === 1 ? '00' : '30';
            result += this.hour < 12 ? 'am' : 'pm';
            return result;
        },
        isBlockPassed() {
            const endTime = moment(`${this.hour}:${this.division === 1 ? '29' : '59'}`, 'HH:mm');
            const currentTime = moment(this.current_time, 'HH:mm');
            if(currentTime.startOf('minute') > endTime.startOf('minute')) {
                return true;
            }
            return false;
        },
        isBlockCurrent() {
            if(this.isBlockPassed) return false;
            
            const currentTime = moment(this.current_time, 'HH:mm')
            if(this.hour !==  currentTime.hour()) return false;

            if(this.division === 1 && currentTime.minute() < 30) return true;
            if(this.division === 2 && currentTime.minute() >= 30) return true;
        },
        currentTimeFormatted() {
            return this.current_time.format('h:mm:ss a');
        },
    },
    watch: {
        bells(newBells) {
            const newSlots = [null, null, null, null, null, null];
            const numSlots = 6;

            for(let bell of newBells) {
                let bell_offset = moment(bell.schedule_time, 'hh:mma').minute();
                let slot_index = this.slotHash(bell_offset);
                while(newSlots[slot_index] !== null) {
                    slot_index++;
                    if(slot_index === numSlots) {
                        let curr_index = --slot_index;
                        while(curr_index > 0 && newSlots[curr_index] !== null) {
                            curr_index--;
                        } 
                        while(curr_index < slot_index) {
                            newSlots[curr_index] = newSlots[++curr_index];
                        }
                        break;
                    }
                }
                newSlots[slot_index] = bell;
            }
            this.slots = newSlots;
        },
        isBlockCurrent: {
            handler(isCur, wasCur) {
                if(!wasCur && isCur) {
                    this.$emit('block-enter', this.hour, this.division)
                }
            },
            immediate: true
        }
    }
}
</script>

<style>
.schedule-block {
    position: relative;
    text-align: left;
    font-size: small;

    display: flex;
    flex-direction: column;
}

.schedule-block.passed {
    opacity: 0.4;
    background-color: rgba(0, 0, 0, 0.2);
}

.schedule-block::before {
    content: "";
    display: inline-block;
    position: absolute;
    width: 100%;
    height: 1px;
    z-index: 1;
    background-color: #aaa;
}

span.current-time-marker {
    position: absolute;
    width: 100%;
    margin: 0;
    padding: 0;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.1);
    border-bottom: 2px solid rgba(255, 0, 0, 0.5);
}

span.current-time-marker::after {
    content: "";
    position: absolute;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 100%;
    bottom: -5px;
    background-color: rgba(255, 0, 0, 0.5);
}

.label {
    position: absolute;
}
</style>